import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDataTable,
  CPagination,
  CRow,
  CLabel,
  CInputGroup,
  CInputGroupText,
  CInput,
  CSelect,
  CTooltip,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getItem, getList } from "../../api/generics";
import { getRoutePath } from "../../routes";
import { SUCCESS } from "../../utils/constants/tags";
import { warningAlert } from "../utils/messages";

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";

import { formatToCurrency } from "../../currency/format";
import { PYG } from "../../currency/available-currencies";

import SingleStoreSelect from "../store/SingleStoreSelect";
import Store from "../../models/store";
import SoldSumaryEntry from "../../models/sold-summary";
import generateSummaryReportPDF from "../../utils/summaryPdfGenerator";
import { formatDateTime } from "../../utils/dates";
import User from "../../models/user";
import UserSelect from "../user/UserSelect";
import { Spinner } from "react-bootstrap";

const ITEMS_PER_PAGE = 1200;
const ITEMS_PER_PAGE_FOR_REPORT = -1; // Basically No limit

export const SUMMARYTYPES: { [key: string]: string } = {
  categories: "Categorías",
  products: "Productos",
  colors: "Producto+Colores",
};

export const OWNERTYPES: { [key: string]: string } = {
  donna: "DONNA",
  jeans: "JEANS",
  international: "Internacional",
  rigido: "Rígido",
};

const AmountsSummary = () => {
  const fields = [
    {
      key: "counter",
      _classes: ["text-center"],
      label: "#",
    },
    {
      key: "name",
      _classes: ["text-center"],
      label: "Nombre",
    },
    {
      key: "amount",
      _classes: ["text-center"],
      label: "Cantidad",
    },
    {
      key: "soldPrice",
      _classes: ["text-center"],
      label: "Valor de venta",
    },
    {
      key: "profit",
      _classes: ["text-center"],
      label: "Ganancia estimada",
    },
  ];

  const [filterStore, setFilterStore] = useState<Store | undefined>(undefined);
  const [filterCategoryOwner, setFilterCategoryOwner] = useState<string>("");
  const [filterUser, setFilterUser] = useState<User | undefined>(undefined);
  const [startDate, setStartDate] = useState<string | moment.Moment>("");
  const [endDate, setEndDate] = useState<string | moment.Moment>("");
  const [viewType, setViewType] = useState<string>("categories");
  const [search, setSearch] = useState<string>("");

  const [loading, setLoading] = useState(true);

  const [tableEntries, setTableEntries] = useState<SoldSumaryEntry[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const history = useHistory();

  const [pageTotalPrice, setPageTotalPrice] = useState<number | undefined>(0);
  const [pageTotalProfit, setPageTotalProfit] = useState<number | undefined>(0);
  const [pageTotalCost, setPageTotalCost] = useState<number | undefined>(0);

  const [enableReportButton, setEnableReportButton] = useState(true);
  const [generatingReport, setGeneratingReport] = useState(false);

  const getURLParams = () => {
    let urlParams = new URLSearchParams(history.location.search);
    let page = urlParams.get("page")
      ? parseInt(urlParams.get("page") as string)
      : 1;

    if (page <= 0) {
      page = 1;
    }
    let search = urlParams.get("search") ? urlParams.get("search") : "";
    let owner = urlParams.get("owner") ? urlParams.get("owner") : "";
    let view_products = urlParams.get("view") ? urlParams.get("view") : "";
    let storeId = urlParams.get("store_id") ? urlParams.get("store_id") : "";
    let sellerId = urlParams.get("seller_id") ? urlParams.get("seller_id") : "";
    let startDate = urlParams.get("start_date")
      ? urlParams.get("start_date")
      : "";
    let endDate = urlParams.get("end_date") ? urlParams.get("end_date") : "";
    let map = new Map();
    map.set("search", search);
    map.set("page", page);
    if (view_products !== "") map.set("view", view_products);
    if (owner !== "") map.set("owner", owner);
    if (startDate !== "") map.set("start_date", startDate);
    if (endDate !== "") map.set("end_date", endDate);
    if (storeId !== "") map.set("store_id", storeId);
    if (sellerId !== "") map.set("seller_id", sellerId);
    return map;
  };

  const fetchEntries = async () => {
    const urlParams = getURLParams();
    const limit = ITEMS_PER_PAGE;
    const offset = ITEMS_PER_PAGE * Number(urlParams.get("page") - 1);
    const summaryStatus = await getList<SoldSumaryEntry>(
      "/amounts_summary/",
      limit,
      offset,
      urlParams
    );
    if (summaryStatus.status === SUCCESS) {
      if (summaryStatus.data !== undefined) {
        const count = summaryStatus.data.count;
        const pages = Math.ceil((count ? count : 0) / ITEMS_PER_PAGE);
        setTotalPages(pages);
        setTableEntries(summaryStatus.data.items);
        setCurrentPage(urlParams.get("page"));
        const totalPrice = calculatePageTotalPrice(summaryStatus.data.items);
        const totalProfit = calculatePageTotalProfit(summaryStatus.data.items);
        setPageTotalPrice(totalPrice);
        setPageTotalProfit(totalProfit);
        setPageTotalCost(totalPrice - totalProfit);
      }
    } else {
      const message = summaryStatus.detail
        ? summaryStatus.detail
        : "Error desconocido";
      warningAlert(message);
    }
    setLoading(false);
  };

  const fetchEntriesReport = async () => {
    setEnableReportButton(false);
    const urlParams = getURLParams();
    urlParams.set("descending", "false");
    const limit = ITEMS_PER_PAGE_FOR_REPORT;
    const offset = 0;
    const storeSalesStatus = await getList<SoldSumaryEntry>(
      "/amounts_summary/",
      limit,
      offset,
      urlParams
    );
    if (storeSalesStatus.status === SUCCESS) {
      if (storeSalesStatus.data !== undefined) {
        const filteredPerReport = storeSalesStatus.data.items.filter(
          (item) => item.amount !== undefined && item.amount !== 0
        );
        return filteredPerReport;
      }
      return [];
    } else {
      return [];
    }
  };

  const onPageChange = (page: number) => {
    setLoading(true);
    let urlParams = new URLSearchParams(history.location.search);
    let previousParams = getURLParams();
    urlParams.set(
      "search",
      previousParams.get("search") ? previousParams.get("search") : ""
    );
    if (previousParams.get("view")) {
      urlParams.set("view", previousParams.get("view"));
    }
    if (previousParams.get("owner")) {
      urlParams.set("owner", previousParams.get("owner"));
    }
    if (previousParams.get("store_id")) {
      urlParams.set("store_id", previousParams.get("store_id"));
    }
    if (previousParams.get("seller_id")) {
      urlParams.set("seller_id", previousParams.get("seller_id"));
    }
    if (previousParams.get("start_date")) {
      urlParams.set("start_date", previousParams.get("start_date"));
    }
    if (previousParams.get("end_date")) {
      urlParams.set("end_date", previousParams.get("end_date"));
    }
    urlParams.set("page", page.toString());
    let url = `?${urlParams.toString()}`;
    history.push(url);
  };

  const onStartDatehange = (value: string | moment.Moment) => {
    const newDate = value as moment.Moment;
    if (newDate === undefined || !moment(value, true).isValid()) {
      setStartDate("");
      return;
    }
    setStartDate(value);
  };

  const onEndDatehange = (value: string | moment.Moment) => {
    const newDate = value as moment.Moment;
    if (newDate === undefined || !moment(value, true).isValid()) {
      setEndDate("");
      return;
    }
    setEndDate(value);
  };

  const onViewTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setViewType(e.target.value);
  };

  const onOwnerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterCategoryOwner(e.target.value);
  };

  const onFilterUserChange = (newUser: User | null) => {
    setFilterUser(newUser !== null ? newUser : undefined);
  };

  const onFilterStoreChange = (newStore: Store | null) => {
    setFilterStore(newStore !== null ? newStore : undefined);
  };

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onSearch = () => {
    setLoading(true);
    let urlParams = new URLSearchParams(history.location.search);
    if (filterCategoryOwner !== "") {
      urlParams.set("owner", filterCategoryOwner);
    } else {
      urlParams.delete("owner");
    }
    if (search !== "") {
      urlParams.set("search", search);
    } else {
      urlParams.delete("search");
    }
    if (viewType === "products") {
      urlParams.set("view", "products");
    } else if (viewType === "categories") {
      urlParams.set("view", "categories");
    } else if (viewType === "colors") {
      urlParams.set("view", "colors");
    } else {
      urlParams.delete("view");
    }
    if (filterStore !== undefined && filterStore.id !== undefined) {
      urlParams.set("store_id", filterStore.id.toString());
    } else {
      urlParams.delete("store_id");
    }
    if (filterUser !== undefined && filterUser.id !== undefined) {
      urlParams.set("seller_id", filterUser.id.toString());
    } else {
      urlParams.delete("seller_id");
    }
    if (moment.isMoment(startDate)) {
      urlParams.set("start_date", startDate.toISOString());
    } else if (startDate !== undefined && startDate !== "") {
      urlParams.set("start_date", startDate);
    } else {
      urlParams.delete("start_date");
    }
    if (moment.isMoment(endDate)) {
      urlParams.set("end_date", endDate.toISOString());
    } else if (endDate !== undefined && endDate !== "") {
      urlParams.set("end_date", endDate);
    } else {
      urlParams.delete("end_date");
    }
    let url = `?${urlParams.toString()}`;
    history.push(url);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  const evaluateReport = async () => {
    setGeneratingReport(false);
    const urlParams = getURLParams();

    const startDateStr = urlParams.get("start_date");
    const endDateStr = urlParams.get("end_date") || new Date().toISOString();

    if (!startDateStr) {
      setEnableReportButton(false);
      return;
    }

    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      setEnableReportButton(false);
      return;
    }

    const diffInDays = Math.floor(
      (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
    );
    if (diffInDays > 31) {
      setEnableReportButton(false);
      return;
    }
    setEnableReportButton(true);
  };

  const calculatePageTotalProfit = (entries: SoldSumaryEntry[]): number => {
    const total = entries.reduce((acc, entry) => {
      const price = entry.profit ?? 0;
      return acc + price;
    }, 0);

    return total;
  };

  const calculatePageTotalPrice = (entries: SoldSumaryEntry[]): number => {
    const total = entries.reduce((acc, entry) => {
      const price = entry.soldPrice ?? 0;
      return acc + price;
    }, 0);

    return total;
  };

  const onReportClick = async () => {
    setEnableReportButton(false);
    setGeneratingReport(true);
    const urlParams = getURLParams();

    const startDateStr = urlParams.get("start_date");
    const endDateStr = urlParams.get("end_date") || new Date().toISOString();

    if (!startDateStr) {
      warningAlert(
        "El rango de fechas para reporte no debe ser mayor a un mes (31 días)."
      );
      setEnableReportButton(true);
      setGeneratingReport(false);
      return;
    }

    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    // Verificar que las fechas sean válidas
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      warningAlert("Los parámetros de fechas son inválidos.");
      setEnableReportButton(true);
      setGeneratingReport(false);
      return;
    }

    // Verificar rango de fechas (máximo 31 días)
    const diffInDays = Math.floor(
      (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
    );
    if (diffInDays > 31) {
      warningAlert(
        "El rango de fechas para reporte no debe ser mayor a un mes (31 días)."
      );
      setEnableReportButton(true);
      setGeneratingReport(false);
      return;
    }
    const reportEntries = await fetchEntriesReport();
    if (reportEntries.length <= 0) {
      warningAlert("No se han seleccionado ventas");
      setEnableReportButton(true);
      setGeneratingReport(false);
      return;
    }

    let storeName = "";
    if (urlParams.get("store_id")) {
      storeName = await fetchStoreName(urlParams.get("store_id"));
    }
    const titlesRight: string[] = generateTitlesRight(urlParams);

    if (storeName !== "") {
      titlesRight.push(`Sucursal: ${storeName}`);
    }

    const filteredTitlesRight = titlesRight.filter((title) => title !== "");

    await generateSummaryReportPDF(
      reportEntries,
      [
        "Reporte General",
        "",
        "Reporte generado el:",
        formatDateTime(new Date()),
      ],
      filteredTitlesRight
    );
    setEnableReportButton(true);
    setGeneratingReport(false);
  };

  const generateTitlesRight = (map: Map<any, any>): string[] => {
    const titlesRight: string[] = ["Filtros Utilizados: "];

    map.forEach((value, key) => {
      const stringKey = typeof key === "string" ? key : "";
      const stringValue = typeof value === "string" ? value : "";
      const description = getFilterDescription(stringKey, stringValue);
      titlesRight.push(description);
    });

    return titlesRight;
  };

  const getFilterDescription = (key: string, value: string) => {
    switch (key) {
      case "search":
        if (value !== "") {
          return `Búsqueda: ${value}`;
        } else {
          return "";
        }
      case "view":
        return `Tipo: ${getViewTypeName(value)}`;
      case "start_date":
        return `Fecha de inicio: ${formatDateTime(new Date(value))}`;
      case "end_date":
        return `Fecha de fin: ${formatDateTime(new Date(value))}`;
      default:
        return "";
    }
  };

  const getViewTypeName = (key: string): string => {
    return SUMMARYTYPES[key] || "-";
  };

  const fetchStoreName = async (id: string) => {
    if (id === "") {
      return id;
    }
    const storeStatus = await getItem<Store>(`/stores/${id}/`);
    if (storeStatus.status === SUCCESS) {
      if (storeStatus.data !== undefined) {
        return storeStatus.data.name || "";
      }
    }
    return "";
  };

  useEffect(() => {
    fetchEntries();
    evaluateReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return history.listen((location) => {
      if (location.pathname !== getRoutePath("amountsSummary")) {
        return;
      }
      fetchEntries();
      evaluateReport();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <>
      <CRow>
        <CCol lg="12">
          <CCard>
            <CCardHeader className="d-flex flex-row mb-3">
              <div className="p-2 ">
                <h3>Resumen Categorías / Productos</h3>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol>
                  {generatingReport ? (
                    <CButton
                      color="danger"
                      className="fa-solid fa-file-pdf"
                      onClick={onReportClick}
                      disabled={!enableReportButton}
                    >
                      <Spinner
                        animation="grow"
                        style={{
                          height: "17px",
                          width: "17px",
                          marginTop: "auto",
                          marginBottom: "auto",
                          marginRight: "10px",
                        }}
                      />
                      Generando...
                    </CButton>
                  ) : (
                    <CTooltip
                      content={
                        !enableReportButton || loading
                          ? "Debe seleccionar un rango máximo de 31 días"
                          : "La generación de un reporte podria demorar unos minutos. Tenga paciencia"
                      }
                    >
                      <CButton
                        color="danger"
                        className="fa-solid fa-file-pdf"
                        onClick={onReportClick}
                        disabled={!enableReportButton || loading}
                      ></CButton>
                    </CTooltip>
                  )}
                  <p>
                    La generación de reporte esta limitada a un rango de 1 mes
                  </p>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <h5>Filtros</h5>
                </CCol>
              </CRow>
              <CRow className={"mt-2"}>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Vizualizar:</CLabel>
                </CCol>
                <CCol>
                  <CSelect
                    type="text"
                    defaultValue={viewType !== null ? viewType : ""}
                    onChange={onViewTypeChange}
                  >
                    {Object.entries(SUMMARYTYPES).map(([key, entry], ix) => {
                      return (
                        <option key={ix} value={key}>
                          {entry}
                        </option>
                      );
                    })}
                  </CSelect>
                </CCol>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Dueño:</CLabel>
                </CCol>
                <CCol>
                  <CSelect
                    type="text"
                    defaultValue={filterCategoryOwner}
                    onChange={onOwnerChange}
                  >
                    <option value={""}>-------</option>
                    {Object.entries(OWNERTYPES).map(([key, entry], ix) => {
                      return (
                        <option key={ix} value={key}>
                          {entry}
                        </option>
                      );
                    })}
                  </CSelect>
                </CCol>
              </CRow>
              <CRow>
                <CCol></CCol>
              </CRow>
              <CRow className={"mt-2"}>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Desde:</CLabel>
                </CCol>
                <CCol>
                  <Datetime
                    className="pl-0"
                    onChange={onStartDatehange}
                    value={startDate}
                    locale="es/PY"
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    closeOnSelect={true}
                  ></Datetime>
                </CCol>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Hasta:</CLabel>
                </CCol>
                <CCol>
                  <Datetime
                    className="pl-0"
                    onChange={onEndDatehange}
                    value={endDate}
                    locale="es/PY"
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    closeOnSelect={true}
                  ></Datetime>
                </CCol>
              </CRow>
              <CRow className={"mt-2"}>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Sucursal:</CLabel>
                </CCol>
                <CCol>
                  <SingleStoreSelect
                    value={filterStore ? filterStore : null}
                    onChange={onFilterStoreChange}
                  ></SingleStoreSelect>
                </CCol>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Usuario Venta:</CLabel>
                </CCol>
                <CCol>
                  <UserSelect
                    value={filterUser ? filterUser : null}
                    onChange={onFilterUserChange}
                  ></UserSelect>
                </CCol>
              </CRow>

              <CRow>
                <CCol>
                  <CLabel
                    className="visually-hidden"
                    htmlFor="autoSizingInputGroup"
                  ></CLabel>
                  <CInputGroup>
                    <CInputGroupText>
                      <i className="fa fa-search"></i>
                    </CInputGroupText>
                    <CInput
                      type="text"
                      placeholder="Introduzca el termino de busqueda"
                      onChange={onSearchChange}
                      value={search}
                      onKeyDown={handleKeyDown}
                    />
                    <CButton
                      type="button"
                      color="primary"
                      variant="outline"
                      onClick={onSearch}
                      disabled={loading}
                    >
                      Filtrar
                    </CButton>
                  </CInputGroup>
                </CCol>
              </CRow>
              <div>
                <CDataTable
                  noItemsView={<h2 className="text-center">Sin Resultados</h2>}
                  addTableClasses={"table-fixed"}
                  fields={fields}
                  items={tableEntries}
                  striped
                  border
                  loading={loading}
                  responsive
                  scopedSlots={{
                    soldPrice: (item: SoldSumaryEntry) => {
                      return (
                        <td className="text-center">
                          {formatToCurrency(item.soldPrice, PYG)}
                        </td>
                      );
                    },
                    profit: (item: SoldSumaryEntry) => {
                      return (
                        <td className="text-center">
                          {formatToCurrency(item.profit, PYG)}
                        </td>
                      );
                    },
                    counter: (_: SoldSumaryEntry, ix: number) => {
                      return <td className="text-center">{ix + 1}</td>;
                    },
                  }}
                />
                <div className="d-flex justify-content-center">
                  <CPagination
                    pages={totalPages}
                    activePage={currentPage}
                    onActivePageChange={(i: number) => onPageChange(i)}
                    className={totalPages < 2 ? "d-none" : ""}
                  />
                </div>
              </div>
              <CRow className={"mt-2"}>
                <CCol className={"border border-dark"}>
                  <CRow className={"mt-2"}>
                    <CCol>
                      <h5>Valores Totales de selección:</h5>
                    </CCol>
                  </CRow>
                  <CRow className={"mt-2"}>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Venta total:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {pageTotalPrice
                          ? formatToCurrency(pageTotalPrice, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                  </CRow>
                  <CRow className={"mt-2"}>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Ganancia total:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {pageTotalProfit
                          ? formatToCurrency(pageTotalProfit, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                  </CRow>
                  <CRow className={"mt-2"}>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Costo total:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {pageTotalCost
                          ? formatToCurrency(pageTotalCost, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  );
};

export default AmountsSummary;
